import { CancelToken } from "axios"
import { CANCEL } from "redux-saga"
import qs from "qs"

import fetch from "core/fetch"
import CONFIG from "core/config"

export function get(number) {
  const source = CancelToken.source()
  const params = qs.stringify({
    tracking_numbers: number,
  })
  const options = {
    cancelToken: source.token,
    url: `${CONFIG.apiHost}?${params}`,
    method: "GET",
  }
  const promise = fetch(options)
  promise[CANCEL] = source.cancel

  return promise
}

export default {
  get,
}



// WEBPACK FOOTER //
// ./src/data/fetch/parcels/single.js